import { render, staticRenderFns } from "./MyLiteFormRuntime.vue?vue&type=template&id=1c584da6&scoped=true&"
import script from "./MyLiteFormRuntime.vue?vue&type=script&lang=js&"
export * from "./MyLiteFormRuntime.vue?vue&type=script&lang=js&"
import style0 from "./MyLiteFormRuntime.vue?vue&type=style&index=0&id=1c584da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c584da6",
  null
  
)

export default component.exports